import * as React from 'react';
import type { RatingIconProps } from '../../RatingsInput.types';
import { TestIds } from '../constants';

export const RatingIcon: React.FC<RatingIconProps> = props => {
  const { svg, className, onClick } = props;
  return (
    <span
      className={className}
      onClick={onClick}
      data-testid={TestIds.ratingsIcon}
      aria-hidden="true"
    >
      {svg}
    </span>
  );
};
